export default "__VITE_ASSET__DB7e08y5__"